import React from 'react';
import ReactDOM from 'react-dom/client';
// Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
// Bootstrap Icons
import 'bootstrap-icons/font/bootstrap-icons.css';
// Custom CSS (must come after Bootstrap to override)
import './index.css';
import App from './App';
import { reportWebVitals } from './utils/reportWebVitals';
import { initializeColorMode } from './utils/colorMode';
// Bootstrap JS
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Initialize Bootstrap color mode before rendering
initializeColorMode();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Performance measuring
reportWebVitals();